/**
 * Turn a `/api/bd-eligibility` response body into a yes/no.
 *
 * Clone of externalIntegrationsCapability.ts's exact reasoning: kept in its
 * own import-free module so the rule is testable without a network stub,
 * and strict `=== true` on purpose — a truthy `1` or `"true"` is a backend
 * contract change, not permission, and must read as denied.
 */
export function parseBdAssistantCapability(payload: unknown): boolean {
  return (payload as any)?.capabilities?.bd_assistant_eligible === true;
}

export default parseBdAssistantCapability;
